export const RoiCell = ({ grade, legacy, testId, whatIf }) => {
  if (!grade) {
    return (
      <td className="px-2 py-1.5 text-right text-slate-600" data-testid={testId}
        title={legacy ? 'Sent before ticket capture — not gradable' : 'Awaiting official result'}>
        {legacy ? 'n/a' : '—'}
      </td>
    );
  }
  const pos = grade.roi > 0;
  if (whatIf) {
    return (
      <td className="px-2 py-1.5 text-right whitespace-nowrap text-slate-500 italic" data-testid={testId}
        title={`Not sent — what-if only: wagered $${grade.wagered.toFixed(2)} → returned $${grade.returned.toFixed(2)}`}>
        what-if {pos ? '+' : ''}{grade.roi.toFixed(1)}%
      </td>
    );
  }
  return (
    <td className={`px-2 py-1.5 text-right whitespace-nowrap font-semibold ${pos ? 'text-emerald-400' : grade.roi < 0 ? 'text-rose-400' : 'text-slate-300'}`}
      data-testid={testId} title={`Wagered $${grade.wagered.toFixed(2)} → Returned $${grade.returned.toFixed(2)}${grade.refunded ? ` · $${grade.refunded.toFixed(2)} refunded (late scratch)` : ''}`}>
      {pos ? '+' : ''}{grade.roi.toFixed(1)}%
      <span className="ml-1 font-normal text-slate-500">(${grade.returned.toFixed(2)}/${grade.wagered.toFixed(2)})</span>
      {grade.refunded > 0 && <span className="ml-1 text-amber-400 font-normal" data-testid={`${testId}-refund`}>· ${grade.refunded.toFixed(2)} refunded</span>}
    </td>
  );
};

export const DaySubtotalRow = ({ date, rows, colSpan, label, testId, open, onToggle }) => {
  const sent = rows.filter((r) => r.result?.ok && !r.result?.held);
  const graded = sent.filter((r) => r.grade);
  const w = graded.reduce((a, r) => a + r.grade.wagered, 0);
  const ret = graded.reduce((a, r) => a + r.grade.returned, 0);
  const held = rows.filter((r) => r.result?.held).length;
  const blocked = rows.filter((r) => r.result?.blocked).length;
  const pending = sent.length - graded.length;
  const roi = w ? ((ret - w) / w) * 100 : null;
  const tid = testId || `autotri-day-subtotal-${date}`;
  return (
    <tr className={`border-t text-slate-300 ${label ? 'border-slate-500 bg-slate-700/60' : 'border-slate-700 bg-slate-800/60'} ${onToggle ? 'cursor-pointer hover:bg-slate-700/80 transition-colors' : ''}`}
      data-testid={tid} onClick={onToggle} aria-expanded={onToggle ? !!open : undefined}>
      <td colSpan={colSpan} className="px-2 py-1.5 text-xs">
        {onToggle && <span className="inline-block w-4 text-slate-400" data-testid={`${tid}-toggle`}>{open ? '▾' : '▸'}</span>}
        <b>{label || `${date} subtotal`}</b> · {graded.length} graded play{graded.length === 1 ? '' : 's'}
        {graded.length > 0 && (
          <span className="ml-2 font-semibold text-slate-200" data-testid={`${tid}-hitrate`}>
            HitRate {Math.round((graded.filter((r) => r.grade.returned > 0).length / graded.length) * 100)}%
            <span className="ml-1 font-normal text-slate-500">({graded.filter((r) => r.grade.returned > 0).length}/{graded.length})</span>
          </span>
        )}
        {pending > 0 && ` · ${pending} awaiting result`}{held > 0 && ` · ${held} held (excluded)`}{blocked > 0 && ` · ${blocked} blocked (excluded)`}
      </td>
      {roi === null ? (
        <td className="px-2 py-1.5 text-right text-slate-600" data-testid={`${tid}-roi`}>—</td>
      ) : (
        <td className={`px-2 py-1.5 text-right whitespace-nowrap font-bold ${roi > 0 ? 'text-emerald-400' : roi < 0 ? 'text-rose-400' : 'text-slate-300'}`} data-testid={`${tid}-roi`}>
          {roi > 0 ? '+' : ''}{roi.toFixed(1)}%
          <span className="ml-1 font-normal text-slate-500">(${ret.toFixed(2)}/${w.toFixed(2)})</span>
        </td>
      )}
    </tr>
  );
};
